import axios from 'axios'
const service = axios.create()
export default {
   async SetCurrentSiteId (queryParameters) {
      return service
      .post('/api/ajax/UserApi/SetCurrentSiteId', queryParameters)
      .then(function (response) {
         return response.data
      })
   },
   async GetCmsConfigByChainId (queryParameters) {
      return service
      .post('/api/ajax/HomepageApi/GetCmsConfigByChainId', queryParameters)
      .then(function (response) {
         return response.data
      })
   },
   async GetAllHomepageCmsConfigsByChainId (queryParameters) {
      return service
      .post('/api/ajax/HomepageNuxtApi/GetAllHomepageCmsConfigsByChainId', queryParameters)
      .then(function (response) {
         return response.data
      })
   },
   async GetNumberOfSitesInChain (queryParameters) {
      return service
      .post('/api/ajax/HomepageNuxtApi/GetNumberOfSitesInChain', queryParameters)
      .then(function (response) {
         return response.data
    })
   },
   async GetDepartmentsByChainId (queryParameters) {
      return service
      .post('/api/ajax/HomepageNuxtApi/GetDepartmentsByChainId', queryParameters)
      .then(function (response) {
         return response.data
      })
   },
   async CreateNewHomepage (queryParameters) {
      return service
      .post('/api/ajax/HomepageNuxtApi/CreateNewHomepage', queryParameters)
      .then(function (response) {
         return response.data
      })
   },
   async DeleteHomepageCmsConfig (queryParameters) {
      return service
      .post('/api/ajax/HomepageNuxtApi/DeleteHomepageCmsConfig', queryParameters)
      .then(function (response) {
         return response.data
      })
   }
}
